exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2N-mH{width:35px;height:35px;padding:0;border:none;color:#6eb7fd;background:#fff;transition-property:border,background,color,opacity;transition-duration:.2s;text-align:center;vertical-align:middle}._2N-mH:hover{color:#3899ec;background:#eaf7ff}._1CDKw{margin-left:8px}", ""]);

// exports
exports.locals = {
	"generic": "_2N-mH",
	"text": "_1CDKw"
};